/** How long an activity created with no steps waits on Today for its first one. */
export const UP_NEXT_WINDOW_MS = 12 * 60 * 60 * 1000;

interface UpNextLike {
  events?: unknown[] | null;
  createdAt?: { toDate?: () => Date } | null;
  sortIndex?: number | null;
}

/**
 * Created ahead of time and waiting for its first step: the airport visit you
 * set up from the plane, ready for Off Plane. Only something created in the
 * last 12 hours counts, so an old empty record or a backfilled note (which has
 * a `sortIndex`) never lingers on Today.
 */
export function isAwaitingFirstStep(i: UpNextLike, nowMs: number = Date.now()): boolean {
  if (i.events && i.events.length > 0) return false;
  if (i.sortIndex != null) return false;
  const created = i.createdAt?.toDate?.()?.getTime();
  if (created == null) return false;
  const age = nowMs - created;
  return age >= -60_000 && age < UP_NEXT_WINDOW_MS;
}

/** Those activities, newest first. */
export function upNextActivities<T extends UpNextLike>(activities: T[], nowMs: number = Date.now()): T[] {
  const createdMs = (i: T) => i.createdAt?.toDate?.()?.getTime() ?? 0;
  return activities.filter((i) => isAwaitingFirstStep(i, nowMs)).sort((a, b) => createdMs(b) - createdMs(a));
}
